module.exports = __webpack_public_path__ + "img/curtain_up_40.e0d382dd.svg";